<template>
  <div>
    <validation-observer>
      <b-form>
        <b-row>
          <b-col
            v-for="(col, index) in employmentData1"
            :key="col.field || index"
            md="4"
          >
            <validation-observer :ref="`simpleRules${col.field}`">
              <validation-provider
                #default="{ errors }"
                :name="col.label"
                :rules="col.formOption ? col.formOption.rules : ''"
              >
                <div
                  v-if="col.disabled"
                  style="padding-left:15px;display:inline-block;"
                >
                  <label :class="{ required: hasRequired(col.formOption) }"
                    >{{ col.label }}:</label
                  ><br />
                  <small class="text-primary">{{ col.small }}</small>
                </div>
                <form-item
                  v-else
                  :required="col.required"
                  :form-label="col.label"
                  :form-value="
                    employmentData[col.dicName ? col.dicName : col.field]
                  "
                  :only-show="col.onlyShow"
                  @saveFormItem="
                    saveFormItem($event, employmentData[col.field], col.field)
                  "
                  @clearFormItem="clearFormItem"
                >
                  <template slot="labelSmall">
                    <small class="text-danger">{{ errors[0] }}</small>
                  </template>
                  <element-component
                    :id="`v-add-${col.field}`"
                    v-model="employmentData[col.field]"
                    :state="errors.length > 0 ? false : null"
                    :label="col.label"
                    :option="col"
                  />
                </form-item>
              </validation-provider>
            </validation-observer>
          </b-col>
        </b-row>
      </b-form>
      <hr class="invoice-spacing" />
      <b-form>
        <b-row>
          <b-col
            v-for="(col, index) in employmentData2"
            :key="col.field || index"
            cols="12"
            md="4"
          >
            <validation-observer :ref="`simpleRules${col.field}`">
              <validation-provider
                #default="{ errors }"
                :name="col.label"
                :rules="col.formOption ? col.formOption.rules : ''"
              >
                <form-item
                  :form-label="col.label"
                  :form-value="
                    employmentData[col.dicName ? col.dicName : col.field]
                  "
                  :only-show="col.onlyShow"
                  @saveFormItem="
                    saveFormItem($event, employmentData[col.field], col.field)
                  "
                  @clearFormItem="clearFormItem"
                >
                  <element-component
                    :id="`v-add-${col.field}`"
                    v-model="employmentData[col.field]"
                    :state="errors.length > 0 ? false : null"
                    :label="col.label"
                    :option="col"
                  />
                </form-item>
              </validation-provider>
            </validation-observer>
          </b-col>
        </b-row>
      </b-form>
      <hr class="invoice-spacing" />
      <b-form>
        <b-row>
          <b-col
            v-for="(col, index) in employmentData3"
            :key="col.field || index"
            cols="12"
            md="4"
          >
            <validation-observer :ref="`simpleRules${col.field}`">
              <validation-provider
                #default="{ errors }"
                :name="col.label"
                :rules="col.formOption ? col.formOption.rules : ''"
              >
                <form-item
                  :form-label="col.label"
                  :form-value="
                    employmentData[col.dicName ? col.dicName : col.field]
                  "
                  :only-show="col.onlyShow"
                  @saveFormItem="
                    saveFormItem($event, employmentData[col.field], col.field)
                  "
                  @clearFormItem="clearFormItem"
                >
                  <element-component
                    :id="`v-add-${col.field}`"
                    v-model="employmentData[col.field]"
                    :state="errors.length > 0 ? false : null"
                    :label="col.label"
                    :option="col"
                  />
                </form-item>
              </validation-provider>
            </validation-observer>
          </b-col>
        </b-row>
      </b-form>
      <hr class="invoice-spacing" />
      <b-form>
        <b-row>
          <b-col
            v-for="(col, index) in employmentData4"
            :key="col.field || index"
            cols="12"
            md="4"
          >
            <validation-observer :ref="`simpleRules${col.field}`">
              <validation-provider
                #default="{ errors }"
                :name="col.label"
                :rules="col.formOption ? col.formOption.rules : ''"
              >
                <form-item
                  :form-label="col.label"
                  :form-value="
                    employmentData[col.dicName ? col.dicName : col.field]
                  "
                  :only-show="col.onlyShow"
                  @saveFormItem="
                    saveFormItem($event, employmentData[col.field], col.field)
                  "
                  @clearFormItem="clearFormItem"
                >
                  <element-component
                    :id="`v-add-${col.field}`"
                    v-model="employmentData[col.field]"
                    :state="errors.length > 0 ? false : null"
                    :label="col.label"
                    :option="col"
                  />
                </form-item>
              </validation-provider>
            </validation-observer>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import WORKER from '@/api/worker/index'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import FormItem from '@/components/FormItem.vue'
import ElementComponent from '@/components/elementComponent.vue'
import CUpload from '@/components/upload/index.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { BCol, BRow, BForm, BAvatar } from 'bootstrap-vue'
import { deepClone } from '@/util/util'

export default {
  components: {
    ElementComponent,
    ValidationProvider,
    ValidationObserver,
    FormItem,
    BForm,
    BRow,
    BCol,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    refreshChange: {
      type: Function,
      default: (done) => {
        done()
      },
    },
    detailType: {
      type: String,
      default: 'view',
    },
  },
  data() {
    return {
      employmentData: {},
      employmentDataCopy: {},
      hasToStringTypes: ['select', 'check'],
    }
  },
  computed: {
    form() {
      // console.log(this.data, 'data+++')
      const res = this.data
      const cols = [
        this.employmentData1,
        this.employmentData2,
        this.employmentData3,
        this.employmentData4,
      ]
      for (let i = 0; i < cols.length; i += 1) {
        const element = cols[i]
        element.forEach((item) => {
          const val = res[item.field]
          if (val || val === 0) {
            const formatVal =
              this.hasToStringTypes.indexOf(item.type) !== -1
                ? val.toString()
                : val
            res[item.field] = formatVal
          }
        })
      }
      return res
    },
    employmentData1() {
      const employmentData1 = [
        {
          label: this.i18n('labelEmployment.joinDate'),
          field: 'joinDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          onlyShow: true,
          required: true,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('labelEmployment.workingSkill'),
          field: 'workingSkill',
          type: 'select',
          dictBizCode: 'working_skill',
          dicName: 'workingSkillName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.companyId'),
          field: 'companyId',
          type: 'select',
          dictBizCode: 'company',
          dicName: 'deptName',
          onlyShow: this.detailType === 'view',
        },
        // {
        //   label: 'Period of Employment',
        //   field: 'periodEmployment',
        // },
        {
          label: this.i18n('labelEmployment.workingAttitude'),
          field: 'workingAttitude',
          type: 'select',
          dictBizCode: 'working_attitude',
          dicName: 'workingAttitudeName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.specialistId'),
          field: 'specialistId',
          type: 'select',
          dictCode: 'special',
          dicName: 'specialistName',
          // disabled: true,
          onlyShow: this.detailType === 'view',
        },
        // {
        //   label: this.i18n('labelEmployment.position'),
        //   field: 'position',
        //   type: 'select',
        //   disabled: !this.data.specialistId,
        //   dictCode: 'position',
        //   dictQuery: {
        //     specialistId: this.data.specialistId,
        //   },
        //   dicName: 'positionName',
        //   small: this.$t('_components.placeholder.firstSelect') + this.i18n('labelEmployment.specialistId'),
        //   onlyShow: this.detailType === 'view',
        // },
        {
          label: this.i18n('labelEmployment.trade'),
          field: 'trade',
          type: 'select',
          disabled: !this.data.specialistId,
          dictCode: 'trade',
          dictQuery: {
            specialistId: this.data.specialistId,
          },
          dicName: 'tradeName',
          small:
            this.$t('_components.placeholder.firstSelect') +
            this.i18n('labelEmployment.specialistId'),
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.position'),
          field: 'position',
          type: 'select',
          dicName: 'positionName',
          dictCode: 'position',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.workingYears'),
          field: 'workingYears',
          onlyShow: true,
        },
        // {
        //   label: this.i18n('labelEmployment.status'),
        //   field: 'status',
        //   type: 'select',
        //   dictBizCode: 'worker_status',
        //   dicName: 'statusName',
        //   onlyShow: this.detailType === 'view',
        // },
        {
          label: this.i18n('label.email'),
          field: 'email',
          required: true,
          formOption: {
            rules: 'required|email',
          },
          onlyShow: this.detailType === 'view',
        },
        // {
        //   label: this.i18n('label.email'),
        //   field: 'passportStatus',
        //   required: true,
        //   formOption: {
        //     rules: 'required',
        //   },
        //   onlyShow: this.detailType === 'view',
        // },
      ]
      return employmentData1
    },
    employmentData2() {
      const employmentData2 = [
        {
          label: this.i18n('labelEmployment.socExpiryDate'),
          field: 'socExpiryDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          onlyShow: this.detailType === 'view',
        },
        // {
        //   label: this.i18n('labelEmployment.position'),
        //   field: 'position',
        //   type: 'select',
        //   dictBizCode: 'worker_position',
        //   dicName: 'positionName',
        // },
        {
          label: this.i18n('labelEmployment.skill'),
          field: 'skill',
          type: 'check',
          dictBizCode: 'worker_skill',
          dicName: 'skillName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.isSupervisor'),
          field: 'isSupervisor',
          type: 'radio',
          dicName: 'isSupervisorName',
          // dictBizCode: 'worker_supervisor',
          onlyShow: true,
        },
        {
          label: this.i18n('labelEmployment.teamName'),
          field: 'teamName',
          onlyShow: true,
        },
        {
          label: this.i18n('labelEmployment.coreTradeReg'),
          field: 'coreTradeReg',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.myeCertificateNo'),
          field: 'myeCertificateNo',
          onlyShow: this.detailType === 'view',
        },
        {
          label: 'CPF A/C',
          field: 'cpfId',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.businessSection'),
          field: 'businessSection',
          type: 'select',
          // dictBizCode: 'business_section',
          dictCode: 'business_section',
          dicName: 'businessSectionName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.level'),
          field: 'level',
          type: 'select',
          dictBizCode: 'worker_level',
          dicName: 'levelName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.restDay'),
          field: 'restDay',
          type: 'select',
          dictBizCode: 'rest_day',
          dicName: 'restDayName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.restRemark'),
          field: 'restRemark',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.operationRemark'),
          field: 'operationRemark ',
          onlyShow: this.detailType === 'view',
        },
      ]
      return employmentData2
    },
    employmentData3() {
      const employmentData3 = [
        {
          label: this.i18n('labelEmployment.passportStatus'),
          field: 'passportStatus',
          onlyShow: this.detailType === 'view',
          type: 'select',
          dicName: 'passportStatusName',
          dictBizCode: 'worker_passport_status',
        },
        {
          label: this.i18n('labelEmployment.transport'),
          field: 'transport',
          type: 'select',
          dicName: 'transportName',
          dictBizCode: 'worker_transport',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.meals'),
          field: 'meals',
          type: 'select',
          dictBizCode: 'worker_meals',
          dicName: 'mealName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.dormitory'),
          field: 'dormitoryId',
          dicName: 'dormitoryName',
          type: 'select',
          dictBizCode: 'dormitory',
          onlyShow: true,
          // onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.blk'),
          field: 'blkId',
          dicName: 'blkName',
          type: 'select',
          dictQuery: {
            dormitoryId: this.data.dormitoryId,
          },
          disabled: !this.data.dormitoryId,
          small:
            this.$t('_components.placeholder.firstSelect') +
            this.i18n('labelEmployment.dormitory'),
          dictBizCode: 'BLk',
          onlyShow: true,
          // onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.room'),
          field: 'roomId',
          type: 'select',
          dictQuery: {
            blkId: this.data.blkId,
          },
          disabled: !this.data.blkId,
          dictBizCode: 'UnitRoom',
          small:
            this.$t('_components.placeholder.firstSelect') +
            this.i18n('labelEmployment.blk'),
          onlyShow: true,
        },
        {
          label: this.i18n('labelEmployment.bankName'),
          field: 'bankName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.bankCode'),
          field: 'bankCode',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.bankAccount'),
          field: 'bankAccount',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.bankNumber'),
          field: 'bankNumber',
          onlyShow: this.detailType === 'view',
        },
      ]
      return employmentData3
    },
    employmentData4() {
      const employmentData4 = [
        {
          label: this.i18n('labelEmployment.wpNumber'),
          field: 'wpNumber',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.wpExpiryDate'),
          field: 'wpExpiryDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.wpLastUpdateDate'),
          field: 'wpLastUpdateDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.wpResignationDate'),
          field: 'wpResignationDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.issueDate'),
          field: 'issueDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.applicateDate'),
          field: 'applicateDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-d',
          dateOutputFormat: 'MMM do yy',
          onlyShow: this.detailType === 'view',
        },
      ]
      return employmentData4
    },
  },
  created() {
    this.onLoad()
  },
  methods: {
    i18n(param) {
      return this.$t(`_worker.${param}`)
    },
    hasRequired(option = {}) {
      const rules = option.rules || ''
      return rules.indexOf('required') !== -1
    },
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.$emit('submit', this.form)
        }
      })
    },
    onLoad() {
      this.loading = true
      this.employmentDataCopy = deepClone(this.form)
      this.employmentData = deepClone(this.form)
      this.loading = false
    },
    resetForm() {
      this.form = {}
      this.$emit('closeForm')
    },
    saveFormItem(done, value, key) {
      this.$refs[`simpleRules${key}`][0].validate().then((success) => {
        if (success) {
          const params = { id: this.form.id, workerId: this.form.workerId }
          params[key] = value
          WORKER.updateEployment(params, { key }).then((res) => {
            let isDone = false
            const refreshDone = () => {
              if (!isDone) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('_default.toast.title'),
                    icon: 'BellIcon',
                    text: this.$t('_default.toast.text.success'),
                    variant: 'success',
                  },
                })
                done()
                this.onLoad()
                isDone = true
              }
            }
            this.refreshChange(refreshDone)
          })
        }
      })
    },
    clearFormItem() {
      this.employmentData = deepClone(this.employmentDataCopy)
    },
  },
}
</script>

<style></style>
